import { IProfile, Profile } from '../profile'

export enum IdentityEvents {
    IDENTITY_CHANGE = 'idChange',
    IDENTITY_INIT = 'idInit'
}

export interface IIdentityEvent extends CustomEvent<IProfile> {
    detail: Profile
}

/**
 * Identity Event factory.
 *
 * @param {IdentityEvents} type
 * @param {IProfile} profile
 */
export const IdentityEvent = (type: IdentityEvents, profile?: IProfile): IIdentityEvent => {
    return new CustomEvent<IProfile>(String(type), { bubbles: true, detail: profile }) as IIdentityEvent
}
